var render, staticRenderFns
import script from "./ActionDetailView.vue?vue&type=script&lang=ts"
export * from "./ActionDetailView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd515d2c')) {
      api.createRecord('bd515d2c', component.options)
    } else {
      api.reload('bd515d2c', component.options)
    }
    
  }
}
component.options.__file = "src/views/actions/Actions/ActionDetailView.vue"
export default component.exports